module.exports = "/_next/static/images/replace-card-illustration-e284b3d74521f123798e7d939b1b935f.svg";